function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var a = /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g;
function o(e) {
  var r, i;
  var n = (r = e.innerText) != null ? r : "",
    t = e.cloneNode(!0);
  if (!(t instanceof HTMLElement)) return n;
  var u = !1;
  var _iterator = _createForOfIteratorHelper(t.querySelectorAll('[hidden],[aria-hidden],[role="img"]')),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var f = _step.value;
      f.remove(), u = !0;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  var l = u ? (i = t.innerText) != null ? i : "" : n;
  return a.test(l) && (l = l.replace(a, "")), l;
}
function g(e) {
  var n = e.getAttribute("aria-label");
  if (typeof n == "string") return n.trim();
  var t = e.getAttribute("aria-labelledby");
  if (t) {
    var u = t.split(" ").map(function (l) {
      var r = document.getElementById(l);
      if (r) {
        var i = r.getAttribute("aria-label");
        return typeof i == "string" ? i.trim() : o(r).trim();
      }
      return null;
    }).filter(Boolean);
    if (u.length > 0) return u.join(", ");
  }
  return o(e).trim();
}
export { g as getTextValue };